export type ValidationErrors = {
    prompt?: string;
    title?: string;
    problem?: string;
    categories?: string;
};

export type FieldValidation = {
    hasError: boolean;
    errorMessage?: string;
};

export const isEmptyValidation = (text: string): FieldValidation => {
    const trimmedText = text.trim();
    if (!trimmedText) {
        return {
            hasError: true,
            errorMessage: 'Обязательное поле для заполнения',
        };
    }

    return { hasError: false };
};

export const validateCategories = (selectedCategories: string[]): FieldValidation => {
    if (selectedCategories.length === 0) {
        return {
            hasError: true,
            errorMessage: 'Обязательное поле для заполнения',
        };
    }

    return { hasError: false };
};

export const validateStep0 = (prompt: string): ValidationErrors => {
    const errors: ValidationErrors = {};

    const promptValidation = isEmptyValidation(prompt);
    if (promptValidation.hasError) {
        errors.prompt = promptValidation.errorMessage;
    }

    return errors;
};

export const validateStep1 = (
    prompt: string,
    title: string,
    problem: string,
    selectedCategories: string[],
): ValidationErrors => {
    const errors: ValidationErrors = {};

    const promptValidation = isEmptyValidation(prompt);
    if (promptValidation.hasError) {
        errors.prompt = promptValidation.errorMessage;
    }

    const titleValidation = isEmptyValidation(title);
    if (titleValidation.hasError) {
        errors.title = titleValidation.errorMessage;
    }

    const problemValidation = isEmptyValidation(problem);
    if (problemValidation.hasError) {
        errors.problem = problemValidation.errorMessage;
    }

    const categoriesValidation = validateCategories(selectedCategories);
    if (categoriesValidation.hasError) {
        errors.categories = categoriesValidation.errorMessage;
    }

    return errors;
};
